import { getAnalytics } from 'firebase/analytics';

import { store } from '../app/store';
import { isDev } from '../utils/environments';
import AnalyticsUtil from './analyticsUtil';

export default class AnalyticsWrapper {
  readonly analyticsObj: any;

  readonly analyticsUtil: any;

  constructor(firebaseApp: any) {
    this.analyticsObj = getAnalytics(firebaseApp);
    this.analyticsUtil = new AnalyticsUtil();
  }

  logEvent(
    eventName: string,
    parameters?: { [key: string]: string },
    description?: string
  ) {
    if (isDev()) {
      // this is to make testing analytics easier
      console.log('logging event', {
        eventName,
        parameters,
        description,
      });
    }
    const sessionID = store.getState().apiScreenScreenSelector.sessionID;
    if (!parameters) parameters = {};

    if (sessionID !== '') {
      parameters.session_id = sessionID;
    }

    if (description) {
      parameters.description = description;
    }

    this.analyticsUtil.writeEvent(eventName, parameters, this.analyticsObj);
  }

  funcError(pkgName: string, funcName: string, reason: string) {
    this.analyticsUtil.funcError(pkgName, funcName, reason);
  }
}
